import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createStackNavigator } from '@react-navigation/stack';
import { AcademyStackParamList } from '../types';
import { View, Platform } from 'react-native';
import AcademyScreen from '@navigation/screens/MidLevel/AcademyScreen/AcademyMain';
import Courses from '@navigation/screens/MidLevel/AcademyScreen/Courses';
import Completed from '@navigation/screens/MidLevel/AcademyScreen/Completed';
import AcademyCourseEditor from '@navigation/screens/MidLevel/AcademyScreen/AcademyCourseEditor';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';

const AcademyStack = Platform.OS === 'web'
	? createStackNavigator<AcademyStackParamList>()
	: createNativeStackNavigator<AcademyStackParamList>();

const AcademyNavigator = () => {
	const theme = themeSelector();
	return (
		<AcademyStack.Navigator
			screenOptions={{ headerShown: false, animation: 'fade', cardStyle: { backgroundColor: theme ? "white" : "black" } }} initialRouteName='AcademyMain'>
				<AcademyStack.Screen name="AcademyMain" component={AcademyScreen} />
				<AcademyStack.Screen name="Courses" component={Courses} />
				<AcademyStack.Screen name="Completed" component={Completed} />
				<AcademyStack.Screen name="Certifications" component={Completed} />
				<AcademyStack.Screen name="CourseEditor" component={AcademyCourseEditor} />
		</AcademyStack.Navigator>
	);
};

export { AcademyStack, AcademyNavigator };
